import { useMemo } from 'react';

import { useFormState } from 'react-final-form';
import { DateRange } from '@cast/shared-types';

import { useWorkloadLabelNamesQuery } from 'hooks/queries/cost';

import { LabelGroupInputs } from './LabelGroupInputs';

import { LabelGroup } from '../../../_types';
import { LabelsFilterSchema } from '../../../validation.schema';
import { useCluster } from '@cast/shared-cluster-context-data-access';

import { InputsStack } from '@cast/shared-rff-ui';

import { Typography, Stack } from '@cast/design-system';

type Props = {
  range: DateRange;
};

export const Form = ({ range }: Props) => {
  const { values } = useFormState<LabelsFilterSchema>();

  const { cluster } = useCluster();
  const { labelNames } = useWorkloadLabelNamesQuery({
    range,
    filter: {
      clusterIds: [cluster.id],
    },
  });

  const addMoreDisabled = useMemo(() => {
    return (
      labelNames?.every((name) =>
        values.labels?.some(({ key }) => key === name)
      ) || values.labels?.some(({ key }) => key === '')
    );
  }, [labelNames, values]);

  return (
    <Stack py={32}>
      <Typography variant="P12M" pb={4}>
        Labels:
      </Typography>
      <InputsStack<LabelGroup>
        name="labels"
        withAddRowButton
        addRowButtonText="Add another label"
        addRowButtonDisabled={addMoreDisabled}
        valueTemplate={{ key: '', value: [] }}
        renderInputsRow={(state) => {
          return <LabelGroupInputs range={range} {...state} />;
        }}
      />
    </Stack>
  );
};
